import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'avn/services/user.service';
import { SharedCompsService } from 'avn/shared/shared-comps.service';
import { ValidatorComponent } from 'avn/shared/validator/validator.component';

@Component({
  selector: 'app-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss']
})
export class ActivateAccountComponent extends ValidatorComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private api: UserService,
    private shared: SharedCompsService
  ) {
    super();
  }

  passwordForm = this.fb.group(
    {
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(25),
          this.uppercaseValidator(),
          this.lowercaseValidator(),
          this.numberValidator(),
          this.specialCharacterValidator()
        ]
      ],
      confirm_password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(25)]]
    },
    {
      validator: this.passwordConfirming
    }
  );

  checkPasswordError(errorType: string): boolean {
    return !!this.passwordForm.controls['password'].errors?.[errorType];
  }

  passwordMaxLengthCheck() {
    if (this.passwordForm.controls['password'].value.length > 25) {
      return true;
    }
    return false;
  }
  passwordMinLengthCheck() {
    if (this.passwordForm.controls['password'].value.length > 7) {
      return true;
    }
    return false;
  }

  passwordConfirming(c: AbstractControl): any {
    if (c.get('password')?.value !== c.get('confirm_password')?.value) {
      return { invalid: true };
    }
  }

  slug: string;
  token: string;
  loading = false;

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      this.slug = params['slug'];
      this.token = params['token'];
    });
  }

  activateAccount() {
    const data = this.passwordForm.value;
    this.loading = true;

    const responseObs = this.api.activateAccount(this.slug, this.token, data);
    responseObs.subscribe({
      next: () => {
        this.loading = false;
        this.shared.showSnackBar('Account activated successfully. Please login to your account', 5);
        this.router.navigate(['/login']);
      },
      error: (error) => {
        this.shared.showSnackBar(error?.error?.message || 'Error in activating account', 5);
      }
    });
  }
}
